import React from 'react';
import ReportPage from './components/ReportPage';
import SLAsBySkuList from './components/SLAsBySkuList';

function SLAsBySku() {
  return (
    <ReportPage title="SLAs by SKU">
      <SLAsBySkuList />
    </ReportPage>
  );
}

export default SLAsBySku;
